import { BlockTitle } from "@blocks/Blocks";
import AboutSection from "@sca/components/FAQ/components/About/AboutSection";
import DinnerSection from "@sca/components/FAQ/components/Dinner/DinnerSection";
import JudgingSection from "@sca/components/FAQ/components/Judging/JudgingSection";
import TimeTableSection from "@sca/components/FAQ/components/TimeTable/TimeTableSection";

/**
 * Component to FAQ Page
 */
const FAQPage = (): React.ReactElement => {
  return (
    <div data-testid="faq-page-component">
      <BlockTitle
        text="FAQ"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6 font-public-sans"
      />

      <AboutSection />

      <JudgingSection />

      <DinnerSection />

      <TimeTableSection />
    </div>
  );
};

export default FAQPage;
